import React, { useContext } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { AuthContext } from '../../../App';
import Support from '../../shared/Support';
import plaid_badge from '../../../lib/images/plaid-logo-badge.png';
import ck_badge from '../../../lib/images/ck-logo-badge.svg';

export default function LinkSuccess() {
  const auth = useContext(AuthContext);
  const role = auth?.auth?.user?.role;

  return (
    <div id="content" className="max-w-xl mx-auto">
      <div className="flex items-center justify-center">
        <img
          alt="Plaid logo badge"
          src={plaid_badge}
          className="w-14 h-14 rounded-full border border-[#E9EDF2]"
        />
        <FontAwesomeIcon
          icon={['far', 'arrows-repeat']}
          className="rounded-full text-xl p-3 text-positive-green"
        />
        <img
          alt="CK logo badge"
          src={ck_badge}
          className="w-14 h-14 rounded-full border border-[#E9EDF2] p-2"
        />
      </div>
      <div className="my-6">
        <p className="text-primary-blue font-avenir-black text-3xl text-center my-3">
          All Set!
        </p>

        <div className="text-center">
          <div className="my-3">
            <p className="text-lg font-avenir-medium">
              You've successfully linked your bank!
            </p>
            <p className="my-3">
              The Credit Key team will review your account information & follow
              up{' '}
              {role === 'merchant'
                ? 'with next steps in 1-3 business days.'
                : 'about your line increase request in 1-2 business days.'}
            </p>
          </div>
        </div>
        <p className="text-center">
          You can contact
          <a
            href="mailto: support@creditkey.com"
            className="text-primary-blue underline cursor-pointer mx-1"
          >
            support@creditkey.com
          </a>
          for updates or questions.
        </p>

        <div className="mt-10 text-center text-dark-gray">
          <Support fullText={true} />
        </div>
      </div>
    </div>
  );
}
